import { IRequestParams, IResultContent, request } from "@fanfanlo";
import { tms } from "../tms";
import { IRequestOptions } from "../IRequestOptions";

/**
 * @description 单个联系人的信息，由前端提供
 */
export interface IEmcContactIdentity {
    identity: string;
    identityType: 'email' | 'mobile';
}

/**
 * @description 邀请联系人的请求参数
 */
export interface IEmcInviteContactsParams extends IRequestParams {
    contacts: IEmcContactIdentity[];
    remark?: string;
    type: string;
    message?: string;
    matrix_access_token: string; // 新增：用于创建 Matrix 房间的授权 Token
}

/**
 * @description 单个邀请的处理结果，由后端返回
 */
export interface IEmcInviteResultItem {
    identity: string;
    result_code: string; // 使用 ResultCode 的字符串形式
    msg: string;
}

/**
 * @description 邀请联系人的完整响应体
 */
// export interface IEmcInviteContactsResult extends IResultContent {
//     data: {
//         data: {
//             results: IEmcInviteResultItem[];
//             msg?: string;
//         };
//         msg?: string;
//     };
//     results?: IEmcInviteResultItem[]; // 保持向后兼容
// }

export interface IEmcInviteContactsResult extends IResultContent {
    data: {
        is_ok:boolean;
        results: IEmcInviteResultItem[];
        msg?: string;
    };
}

/**
 * @description 调用邀请联系人接口的函数
 * @param opts 包含 params, gateway, handler 的请求选项
 */
export async function tmsEmcInviteContacts(opts: IRequestOptions<IEmcInviteContactsParams>) {
    const res = await request<IEmcInviteContactsResult>(tms.TEmc, tms.MEmcInviteContacts, opts.params, opts.gateway, opts.handler);
    return res;
}